export const CareerApplicantStatus = {
  RECEIVED: "received",
  PHONE_SCHEDULED: "phonescheduled",
  FIRST_INTERVIEW_COMPLETE: "1stcomplete",
  ASSIGNED_MANAGER: "assignedmanager",
  REJECTED: "rejected"
}

export function displayApplicantStatus(str) {
  switch (str) {
    case "received":
      return "Received";
    case "phonescheduled":
      return "Screening Scheduled";
    case "1stcomplete":
      return "1st Interview Complete";
    case "assignedmanager":
      return "Assigned To Manager";
    case "rejected":
      return "Rejected";
  }
}

export function getApplicantStatusList() {
  let arr = [];
  for (let key of Object.keys(CareerApplicantStatus)) {
    arr.push(CareerApplicantStatus[key]);
  }
  return arr;
}


// WEBPACK FOOTER //
// ./src/containers/Careers/StatusConstants.js